import {NgModule} from "@angular/core";
import {MarkPipe, MarkPipePure} from "./mark.pipe";

// TODO - we need to decide if we want to move the other mark components to this module (including the MarkService).
// The module was currently created just so we can use the TextAreaContentComponent without importing the RISCommonModule
@NgModule({
	declarations:[MarkPipe,MarkPipePure],
	exports:[MarkPipe,MarkPipePure],
})
export class MarkModule{

}
